// test1655
(1655 && 0);
